<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="name"
    :rules="rules"
    :vid="vid">
    <BaseSelectGroup
      v-model="_value"
      :name="name"
      :placeholder="placeholder"
      :options="options"
      :col="col"
      :label="label"
      :errors="[...errors, ...responseFieldErrors]"
      :disabled="disabled">
      <template #fieldPrepend>
        <slot name="fieldPrepend" />
      </template>
    </BaseSelectGroup>
  </ValidationProvider>
</template>

<script>
import BaseSelectGroup from '@/components/parts/BaseSelectGroup.vue'
export default {
  name: 'BaseSelectGroupWithProvider',
  components: {
    BaseSelectGroup
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    col: {
      type: [String, Number],
      default: 12
    },
    name: {
      type: String,
      default: undefined
    },
    vid: {
      type: String,
      default: null
    },
    rules: {
      type: [String, Array],
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    responseErrors: {
      type: Object,
      default: null
    },
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    hasPlaceholder() {
      return this.placeholder != null
    },
    placeholderOption() {
      return { value: null, text: this.placeholder, disabled: true }
    },
    optionsWithPlaceholder() {
      if (this.hasPlaceholder) {
        return [this.placeholderOption, ...this.options]
      }
      return this.options
    },
    responseFieldErrors() {
      return this.responseErrors?.[this.vid] || null
    }
  },
}
</script>

<style>

</style>